import { AuthContextType } from '../../../containers/login/view-model/contexts/auth-context/AuthContextV1';

export interface AuthBindingUser {
  authToken?: string;
  mobile?: string;
  name?: string;
  requirementType?: string;
  email?: string;
  whatsappConsent?: boolean;
}

export interface AuthBindingType {
  isAuthenticated: boolean;
  user?: AuthBindingUser;
}

export function convertAuthContext(authContext: AuthContextType): AuthBindingType {
  const { is_authenticated, user } = authContext;
  return {
    isAuthenticated: is_authenticated,
    user: user
      ? {
          authToken: user.auth_token,
          mobile: user.mobile,
          name: user.name,
          requirementType: user.requirement_type,
          email: user.email,
          whatsappConsent: user.whatsapp_consent,
        }
      : undefined,
  };
}
